import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import LabelForm from '@/components/labels/LabelForm.vue';
import { UserLabel } from '@/models/label.model';
import { Mutations, ShiftCMSState } from '@/store';
import { LabelsActions, LabelsState } from '@/stores/labels.store';
import { computed, markRaw, onBeforeUnmount, onMounted } from 'vue';
import { useStore } from 'vuex';
import { format } from 'date-fns';


export default /*@__PURE__*/_defineComponent({
  __name: 'LabelsList',
  setup(__props) {

const store = useStore<ShiftCMSState & { ls: LabelsState }>();
const labels = computed<UserLabel[]>(() => store.state.ls.labels);

const update = () => {
  store.dispatch(LabelsActions.GetLabels);
};

onMounted(() => {
  update();
});

onBeforeUnmount(() => {
  store.commit(Mutations.HideDrawer);
});

const editLabel = (_: Event, { item }: { item: UserLabel }) => {
  store.commit(Mutations.ShowDrawer, {
    component: markRaw(LabelForm),
    data: item,
  });
};

const addLabel = () => {
  store.commit(Mutations.ShowDrawer, { component: markRaw(LabelForm) });
};

const headers = [
  { title: 'ID', key: 'id', sortable: false },
  { title: 'Value', key: 'value' },
  { title: 'Date', key: 'creationDate' },
];

return (_ctx: any,_cache: any) => {
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, null, {
    default: _withCtx(() => [
      _cache[1] || (_cache[1] = _createElementVNode("h2", null, "Labels", -1)),
      _createVNode(_component_v_data_table, {
        density: "compact",
        "onClick:row": editLabel,
        headers: headers,
        items: labels.value,
        itemsPerPage: "25",
        hover: ""
      }, {
        "item.creationDate": _withCtx(({ value }) => [
          _createTextVNode(_toDisplayString(_unref(format)(value, 'do MMMM yyyy - HH:mm')), 1)
        ]),
        _: 1
      }, 8, ["items"]),
      _createVNode(_component_v_btn, {
        onClick: addLabel,
        color: "success"
      }, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [
          _createTextVNode("Add Label")
        ])),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})